import router, { constantRoutes } from './router'
import store from './store'

router.beforeEach(async (to, from, next) => {
  let { matched, path } = to
  const [firstMatched] = matched
  if (firstMatched && firstMatched.path) path = firstMatched.path
  if (constantRoutes.findIndex(item => item.path === path) !== -1) {
    next()
  } else {
    const { roles, addRoutes } = store.getters
    const hasRoles = roles && roles.length
    const hasRoutes = addRoutes && addRoutes.length
    if (hasRoles && hasRoutes) {
      next()
    } else {
      console.log('else');
      try {
        console.log('111');
        const { roles } = await store.dispatch('user/getUserInfo')
        const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
        router.addRoutes(accessRoutes)
        console.log(to);
        next({ ...to, replace: true })
      } catch(err) {
        next('/')
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/permission.js